import { Snackbar, Alert } from "@mui/material";
import { useBszFinderContext } from "../../context/bszContext";

export default function BSZAlerts({ actions }) {
  const { snackbar } = useBszFinderContext();

  return (
    <Snackbar
      open={snackbar.open}
      autoHideDuration={3000}
      onClose={actions.handleCloseSnackbar}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
    >
      <Alert
        onClose={actions.handleCloseSnackbar}
        severity={snackbar.severity}
        sx={{ width: "100%" }}
      >
        {snackbar.message}
      </Alert>
    </Snackbar>
  );
}
